import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { noteActions } from '_actions';
import styles from './Common.module.css';
import { ExportButton } from '_components';
import { PatientCareCenterNoteGoalsGoalDetailsFreeFormGoalDetail } from './FreeFormGoalDetail';

class PatientCareCenterNoteGoalsFreeForm extends React.Component {

    convertNote() {
        this.props.convertNote(this.props.noteId, 5); // PN/DN
    }

    render() {
        if (this.props.goals.length > 0) {
            return (
                <div>
                    <div className={styles.stg_header_wrapper}>
                        <div className={styles.stg_header_row}>
                            <div className={styles.stg_header_1}>Free-Form Goals</div>
                        </div>
                    </div>

                    <div className={styles.goals_wrapper}>

                        {Object.keys(this.props.goals)
                            .map(key => {
                                const result = this.props.goals[key];
                                return (
                                    <PatientCareCenterNoteGoalsGoalDetailsFreeFormGoalDetail key={result.GONO} id={result.GONO} />
                                )
                            })
                        }
                    </div>

                    {(this.props.noteType === 2 || this.props.noteType === 4 || this.props.noteType === 6) &&
                        <div>
                            <div className={styles.goal_detail_row}>
                                <label className={styles.convert_msg}>Need to edit additional goal details?  Convert this note to a PN by clicking here:</label>
                            </div>
                            <div className={styles.goal_detail_row}>
                                <span className={styles.convert_button}>
                                    <ExportButton title='Convert to PN/DN' size='large' onClick={() => this.convertNote()} />
                                </span>
                            </div>
                        </div>
                    }

                </div>
            );
        } else {
            return (
                <span />
            );
        }
    }

}

function mapDispatchToProps(dispatch) {
    return {
        convertNote: bindActionCreators(noteActions.convert, dispatch)
    };
}

function mapStateToProps(state) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;
    let noteType = parseInt(noteId.split("_")[0]);
    let pk = parseInt(noteId.split("_")[1]);

    let goals = Object.keys(state.entities.notes.PTGOALS)
        .filter(key => {
            return (
                (noteType === 1 && state.entities.notes.PTGOALS[key].GOEVNO === pk) ||
                (noteType !== 1 && state.entities.notes.PTGOALS[key].GONTNO === pk)
            ) &&
                (state.entities.notes.PTGOALS[key].GODELETED !== true ||
                    (state.entities.notes.PTGOALS[key].GODELETED === true && state.entities.notes.PTGOALS[key].GOGONO)
                )
                && state.entities.notes.PTGOALS[key].GOMGNO === parseInt(state.entities.masterData.PROPS['PTERO_FREE_FORM_GOAL_ID'].PRVALUE)
        })
        .sort((a, b) => {
            return state.entities.notes.PTGOALS[b].GONO - state.entities.notes.PTGOALS[a].GONO;
        })
        .map(key => state.entities.notes.PTGOALS[key]);

    return {
        noteId: noteId,
        noteType: noteType,
        pk: pk,
        goals,
    };
}

const connectedPatientCareCenterNoteGoalsFreeForm = connect(mapStateToProps, mapDispatchToProps)(PatientCareCenterNoteGoalsFreeForm);
export { connectedPatientCareCenterNoteGoalsFreeForm as PatientCareCenterNoteGoalsFreeForm };

